module.exports = __webpack_public_path__ + "img/cover_image_2.3f55707a.png";